import { Box, Button, Card, Tab, Tabs } from '@mui/material'
import { createContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerService } from '../Service';
import Swal from 'sweetalert2';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { ArrowBack } from '@mui/icons-material';
import OtpDetail from './OtpDetail';
import ProfileDetails from './ProfileDetails';
import AddressDetails from './AddressDetails';
import Loading from '../../../components/Loader/Loading';

const StepperDataContext =createContext();
const AddEditCustomer = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'customer'
        });
    }, []);
    const navigate = useNavigate();
    const {id} = useParams();
    
    const otrInitial = {
      mobileNumber : '',
      otp:''
    }
    const [otrDetails,setOtrDetails] = useState(otrInitial);
    const personalDataInitial = {
        firstName: '',
        middleName: '',
        lastName: '',
        gender: '',
        email: '',
        dob: ''
    }
    const [profileData, setProfileData] = useState(personalDataInitial);
    const [addressData, setAddressData] = useState([]);
    const [customerData, setCustomerData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
      
    // const [customerData, setCustomerData] = useState(initialData);
    const fetchCustomerDetailById = async (customerId) => {
        setIsLoading(true);
        try {
          const fetchResponse = await CustomerService.fetchCustomerDetailById(customerId);
          if (fetchResponse.success == '1') {
            const personalDetails= {
              firstName: fetchResponse.data?.profile?.firstName || '',
              middleName: fetchResponse.data?.profile?.middleName || '',
              lastName: fetchResponse.data?.profile?.lastName || '',
              // mobileNumber: fetchResponse.data?.mobileNumber || '',
              dob: fetchResponse.data?.profile?.dob || null,
              email: fetchResponse.data?.profile?.email || '',
              gender: fetchResponse.data?.profile?.gender || '',
            }
            setOtrDetails({
              mobileNumber : fetchResponse.data?.mobileNumber || '',
              otp:''
            })
            setProfileData(personalDetails);
            setAddressData(fetchResponse.data?.customerAllAddress || []);
            setCustomerData(fetchResponse.data);
            if(fetchResponse.data?.isVerified){
              setTabValue('1');
            }
            // reset(modifiedData,{isDirty:false})
    
          } else if (fetchResponse.success == '0') {
            Swal.fire(fetchResponse.message, '', 'error');
          }
        } catch (error) {
          console.log("error",error);
          Swal.fire(error.message, '', 'error');
        }finally{
          setIsLoading(false);
        }
    }
    useEffect(()=>{
        if(id>0){
          fetchCustomerDetailById(id);
        }
    },[id]);
    const [tabValue, setTabValue] = useState('0');
    const handleChange = async (event, newValue) => {
      setTabValue(newValue)
    }
  return (
    <Box>
      {isLoading && <Loading/>}
        <PageHeaderLayout headerTitle={id>0 ? 'Edit Customer Detail':'Add New Customer' } >
        <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
          Back
        </Button>
      </PageHeaderLayout>
      <StepperDataContext.Provider value={{otrDetails,setOtrDetails,profileData,setProfileData,addressData,setAddressData,customerData,tabValue,setTabValue,fetchCustomerDetailById,setCustomerData}}>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            sx={{ p: 0, minHeight: '40px' }}
            variant="scrollable"
            scrollButtons="auto"
          >

            {!customerData?.isVerified && <Tab value="0" disabled={customerData?.isVerified} label="OTR Details" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />}
            <Tab value="1" disabled={id=='0' && !customerData?.id} label="Profile Details" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            <Tab value="2" disabled={!customerData?.profile} label="Address Details" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
            {/* <Tab value="three" label="Item Three" /> */}
          </Tabs>
        </Box>
      </Card>
        {tabValue === '0' && <OtpDetail />}
        {tabValue === '1' && <ProfileDetails />}
        {tabValue === '2' && <AddressDetails />}
      </StepperDataContext.Provider>
    </Box>
  )
}

export default AddEditCustomer

export {StepperDataContext}